import { Trans } from '@lingui/react/macro';
import { User, Lock } from 'lucide-react';
import { Outlet } from '@tanstack/react-router';
import { Avatar, AvatarImage } from '@/common/components/ui/avatar';
import { PageTabs } from '@/common/components/page-tabs/PageTabs';
import { useCurrentUser } from '@/features/auth/hooks/useCurrentUser';
import { avatarUrl } from '@/common/utils/avatarUrl';

export function ProfilePage() {
  const user = useCurrentUser();
  const fullName = [user.firstName, user.lastName].filter(Boolean).join(' ') || user.email;

  return (
    <div className="space-y-6 pb-10">
      <div className="flex items-center gap-4">
        <Avatar className="size-14">
          <AvatarImage src={avatarUrl(user.firstName ?? '', user.lastName ?? '', user.email)} />
        </Avatar>
        <div>
          <h1 className="text-2xl font-bold tracking-tight">{fullName}</h1>
          <p className="text-sm text-muted-foreground mt-0.5">{user.email}</p>
        </div>
      </div>

      <PageTabs>
        <PageTabs.List>
          <PageTabs.Tab to="/profile/personal-info" icon={User}>
            <Trans>Personal info</Trans>
          </PageTabs.Tab>
          <PageTabs.Tab to="/profile/security" icon={Lock}>
            <Trans>Security</Trans>
          </PageTabs.Tab>
        </PageTabs.List>
        <Outlet />
      </PageTabs>
    </div>
  );
}
